import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'
import moment from 'moment';
import axios from 'axios';
import swal from 'sweetalert';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { Pagination, Tooltip } from 'antd';
import { Modal } from "react-bootstrap";

// import { useTheme } from "./theme-provider.js"
import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import PageError from '../common_component/PageError.js';
import StatusBadge from '../common_component/StatusBadge.js';

function InvoiceReplacementList() {

    const [state, setstate] = useState(2);
    const apiController = useRef(new AbortController())
    const [status, setstatus] = useState("");
    const [reason, setReason] = useState("");

    const daterange_picker_ref = useRef()
    const [invoiceReplacementList, setInvoiceReplacementList] = useState([])
    const [invoiceReplacementListApiState, setInvoiceReplacementListApiState] = useState(false)

    const [invoiceReplacementId, setInvoiceReplacementId] = useState("");
    const [approveType, setApproveType] = useState("");
    const [approveModalShow, setApproveModalShow] = useState(false);
    const [statusModalShow, setStatusModalShow] = useState(false);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(100)
    const [searchValue, setSearchValue] = useState(null)
    const [startDate, setStartDate] = useState(moment.utc().subtract(30, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))

    const [itemDetailsModalShow, setItemDetailsModalShow] = useState(false)
    const [itemsData, setItemsData] = useState([])

    const [flowModalShow, setFlowModalShow] = useState(false)

    var page_name = "invoice-replacement-list";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function getInvoiceReplacementList(cp, rpp, search_v, sd, ed) {
        try {
            if (invoiceReplacementListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setInvoiceReplacementListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-invoice-replacement-list`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "start_date": sd, "end_date": ed, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();

            if (body.operation !== "success") throw "get Sales Report api error"
            body.data.list.map((obj) => {
                obj.approve_button_show = false;
                obj.approve_final_button_show = false;

                let t1 = (obj.approval_info)
                let t2 = obj.add_status
                let t3 = obj.approval_level
                let t4 = t1.value.length
                if (t2 == "INVOICE_REPLACEMENT_PENDING_APPROVAL") {
                    if (t1.type == "multilevel_approval") {

                        let tl = t1.value.find(x => x.level == (t3 == null ? 1 : t3 + 1)).user_value
                        if (tl.includes(user.email)) {
                            obj.approve_button_show = true;
                        }
                    }
                    else if (t1.type == "custom_approval") {
                        let ty = t1.value[0]
                        if (ty.user_type == "Group User") {
                            if (ty.user_value.includes(user_role)) {
                                obj.approve_button_show = true;
                            }
                        }
                        else if (ty.user_type == "Individual User") {
                            if (ty.user_value.includes(user.email)) {
                                obj.approve_button_show = true;
                            }
                        }
                    }
                    if (user_role == "Admin") {
                        obj.approve_final_button_show = true;
                    }
                }

            })
            setInvoiceReplacementList(body.data.list)
            setListCount(body.data.count)

            setInvoiceReplacementListApiState(false)
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getInvoiceReplacementList(currentPage, rowsPerPage, searchValue, startDate, endDate)
            Promise.all([p1])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state === 1) {
            getInvoiceReplacementList(currentPage, rowsPerPage, searchValue, startDate, endDate)
        }
    }, [currentPage, rowsPerPage, searchValue, startDate, endDate])

    const approveInvoiceReplacement = (cancel_flag) => {

        var values = { "invoice_replacement_id": invoiceReplacementId, "user_role": user_role, cancel_flag: cancel_flag, cancel_msg: reason, "final_flag": approveType == "final_approve" ? true : false, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-invoice-replacement-details`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal(
                    cancel_flag ? "Cancelled!" : "Great!",
                    cancel_flag
                        ? "Invoice Replacement Cancelled Successfully!"
                        : "Invoice Replacement Approved & Adjusted Successfully!",
                    "success"
                ).then(() => {
                    cancel_flag
                        ? setStatusModalShow(false)
                        : setApproveModalShow(false);
                    getInvoiceReplacementList(currentPage, rowsPerPage, searchValue, startDate, endDate);
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const updateStatus = (obj, type) => {
        setInvoiceReplacementId(obj.invoice_replacement_id);
        setstatus(obj.add_status);
        if (type == "status") {
            setStatusModalShow(true);
        }
        else {
            setApproveModalShow(true);
        }
    }

    return (
        <>
            <div className="">
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Invoice Replacement List</h1>
                    <div className="d-flex align-items-center gap-2">
                        {/* <button className="btn p-0 mx-3 btn-hover-scale">{true ? <i className="bi bi-pin-fill fs-1 px-0"></i> : <i className="bi bi-pin fs-1 px-0"></i>}</button> */}
                        {/* <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/sales/sales_return`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip> */}
                        <Link to={`/create-invoice-replacement`} className="btn btn-sm btn-primary me-3 rounded btn-hover-scale">
                            <span className="d-md-none">
                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                    <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff"></path>
                                </svg>
                            </span>
                            <span className="d-none d-md-inline">Create Invoice Replacement</span>
                        </Link>
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        <DateRangePickerComponent
                                            ref={daterange_picker_ref}
                                            allowEdit={false}
                                            showClearButton={false}
                                            focus={() => { daterange_picker_ref.current.show() }}
                                            delayUpdate={true}
                                            presets={[
                                                { label: 'Today', start: new Date(), end: new Date() },
                                                { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                            ]}
                                            change={(e) => {
                                                setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                            }}
                                            startDate={new Date(startDate)}
                                            endDate={new Date(endDate)}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                </div>

                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                invoiceReplacementListApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    invoiceReplacementList.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    showQuickJumper={true}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                />
                                                            </div>

                                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }} >
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-150px">Replacement Number</th>
                                                                            <th className="min-w-150px">Invoice Number</th>
                                                                            <th className="min-w-150px">Return Number</th>
                                                                            <th className="min-w-150px">Item Details</th>
                                                                            <th className="min-w-150px">Date Added</th>
                                                                            <th className="min-w-150px">Status</th>
                                                                            <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            invoiceReplacementList.map((obj, indx3) => {
                                                                                return (
                                                                                    <tr key={indx3}>
                                                                                        <td><span className="text-dark fw-bold d-block mb-1 fs-6">{obj.invoice_replacement_number}</span></td>
                                                                                        <td><span className="text-dark fw-bold d-block mb-1 fs-6">{obj.customer_invoice_number}</span></td>
                                                                                        <td><span className="text-dark fw-bold d-block mb-1 fs-6">{obj.sales_return_number}</span></td>
                                                                                        <td><button className="text-dark fw-bold d-block btn btn-primary btn-sm fs-5" onClick={() => { setItemDetailsModalShow(true); setItemsData(obj.item_array) }}>view</button></td>
                                                                                        <td><span className="text-dark fw-bold d-block mb-1 fs-6">{moment(obj.add_date_time).format("ll")}</span></td>
                                                                                        <td><StatusBadge status={obj.add_status} entity={"INVOICE_REPLACEMENT"} /></td>
                                                                                        <td className='sticky-column'>
                                                                                            <div className="dropdown">
                                                                                                <button className="btn btn-sm btn-secondary rounded" disabled={obj.add_status !== "INVOICE_REPLACEMENT_PENDING_APPROVAL"} type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                                                {
                                                                                                    write &&
                                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                        {(user_role == "Admin" && (obj.add_status === "INVOICE_REPLACEMENT_PENDING_APPROVAL")) &&
                                                                                                            <li className="py-1"><a onClick={(e) => { updateStatus(obj, "status"); }} className={`dropdown-item cursor-pointer`}>Cancel</a></li>}
                                                                                                        {(obj.approve_final_button_show) &&
                                                                                                            <li className="py-1"><a onClick={(e) => { setApproveType("final_approve"); updateStatus(obj, "approve"); }} className={`dropdown-item cursor-pointer`}>Final Approve & Adjust</a></li>}
                                                                                                        {(obj.approve_button_show) &&
                                                                                                            <li className="py-1"><a onClick={(e) => { setApproveType("approve"); updateStatus(obj, "approve"); }} className={`dropdown-item cursor-pointer`}>Approve</a></li>}
                                                                                                    </ul>
                                                                                                }
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="mt-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No data to be shown {/* <br /> <br />
                                                            <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                Need Help <i className="bi bi-question-circle fs-1"></i>
                                                            </button> */}
                                                        </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div >

            <Modal
                show={itemDetailsModalShow}
                onHide={() => {
                    setItemDetailsModalShow(false);
                    setItemsData([]);
                }}
                size="lg"
                centered
                scrollable
                fullscreen="sm-down"   // Fullscreen on mobile
            >
                <Modal.Header closeButton className="py-2 border-bottom">
                    <Modal.Title className="fw-bold text-primary">
                        Item Details
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="px-3 px-md-4">

                    <div className="table-responsive">
                        <table className="table align-middle table-bordered">
                            <thead className="bg-light-primary">
                                <tr className="text-center">
                                    <th>Item</th>
                                    <th>Type</th>
                                    <th>Stock Info</th>
                                    <th>Returned</th>
                                    <th>Replaced</th>
                                </tr>
                            </thead>

                            <tbody>
                                {itemsData.map((obj, indx) => {

                                    const totalReturnQty =
                                        obj.item_stock_type === "Track Serial Number"
                                            ? (obj.item_data?.length || 0)
                                            : obj.item_stock_type === "Track Batches"
                                                ? obj.item_data?.reduce((sum, b) => sum + (b.unit || 0), 0)
                                                : obj.returned_quantity || 0;

                                    return (
                                        <tr key={indx}>

                                            {/* ITEM NAME */}
                                            <td>
                                                <div className="fw-semibold">
                                                    {obj.item_name}
                                                </div>
                                            </td>

                                            {/* ITEM TYPE */}
                                            <td className="text-center">
                                                <span className="badge bg-light-info text-info px-3 py-2">
                                                    {obj.item_stock_type}
                                                </span>
                                            </td>

                                            {/* STOCK DETAILS */}
                                            <td>
                                                {/* SERIAL */}
                                                {obj.item_stock_type === "Track Serial Number" && (
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {obj.item_data?.map((s, i) => (
                                                            <span
                                                                key={i}
                                                                className="badge bg-light-success text-success"
                                                            >
                                                                {s.serial_name}
                                                            </span>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* BATCH */}
                                                {obj.item_stock_type === "Track Batches" && (
                                                    <div className="d-flex flex-column gap-1">
                                                        {obj.item_data?.map((b, i) => (
                                                            <div key={i} className="small border rounded px-2 py-1">
                                                                <div className="fw-semibold">
                                                                    {b.batch_reference}
                                                                </div>
                                                                <div className="text-muted">
                                                                    Qty: {b.unit}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* NORMAL */}
                                                {obj.item_stock_type !== "Track Serial Number" &&
                                                    obj.item_stock_type !== "Track Batches" && (
                                                        <span className="text-muted">
                                                            Not Applicable
                                                        </span>
                                                    )}
                                            </td>

                                            {/* RETURNED */}
                                            <td className="text-center fw-bold text-danger">
                                                {totalReturnQty}
                                            </td>

                                            {/* REPLACED */}
                                            <td className="text-center fw-bold text-success">
                                                {obj.replaced_quantity || 0}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                </Modal.Body>
            </Modal>

            <Modal show={approveModalShow} onHide={() => { setApproveModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>{approveType === "final_approve" && <>Final</>} Approve Invoice Replacement</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setApproveModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            Current Status is :<StatusBadge status={status} entity={"INVOICE_REPLACEMENT"} />
                            <br />
                            <h3>Are you sure about Approve {approveType === "final_approve" && <>& Adjust</>} Invoice Replacement?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setApproveModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { approveInvoiceReplacement(false) }} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">Approve {approveType === "final_approve" && <>& Adjust</>}</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={statusModalShow} onHide={() => { setStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Cancel Invoice Replacement</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            Current Status is : <StatusBadge status={status} entity={"INVOICE_REPLACEMENT"} /><br />
                            <h3>Are you sure about Cancelling Invoice Replacement?</h3>
                        </div>
                        <div className="row mb-5 mt-3">
                            <div className="col-md-12 my-2">
                                <label className="fs-5 fw-bold mb-2">Reason :</label>
                                <textarea className="form-control form-control-solid" rows="3" value={reason}
                                    onChange={(e) => {
                                        setReason(e.target.value);
                                    }}
                                    placeholder={""}>
                                </textarea>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setStatusModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { approveInvoiceReplacement(true); }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>


            <Modal show={flowModalShow} onHide={() => { setFlowModalShow(false) }} dialogClassName="h-modal-80">
                <Modal.Header>
                    <Modal.Title>
                        <span className='text-gray-500'>Order Flow Cycle</span>
                    </Modal.Title>

                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setFlowModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <img src={'./images/flow_images/customer-order.png'} className='w-100' alt="Not yet provided" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setFlowModalShow(false) }}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default InvoiceReplacementList;